import Nullstack from 'nullstack';
export default function IconBuildingCircus({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-building-circus",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 11h16"
  }), "   ", Nullstack.element("path", {
    d: "M12 6.5c0 1 -5 4.5 -8 4.5"
  }), "   ", Nullstack.element("path", {
    d: "M12 6.5c0 1 5 4.5 8 4.5"
  }), "   ", Nullstack.element("path", {
    d: "M6 11c-.333 5.333 -1 8.667 -2 10h4c1 0 4 -4 4 -9v-1"
  }), "   ", Nullstack.element("path", {
    d: "M18 11c.333 5.333 1 8.667 2 10h-4c-1 0 -4 -4 -4 -9v-1"
  }), "   ", Nullstack.element("path", {
    d: "M12 7v-4l2 1h-2"
  }), " ");
}